import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';

import Shape from '../../common/Shape';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import { usePageView } from '../../../hocs/usePageView';
import { APPOINTMENT_INSPECTION } from '../../../constants';
import AppointmentHeader from '../Components/AppointmentHeader';
import { redirectToVisitType } from '../../../utils/appointments/redirect-utils';
import { enhance } from './enhance';

function AppointmentServices({
  setService,
  inspectAll,
  careUser,
  services,
  subtitle,
}) {
  usePageView('Get Care | Services');

  const handleServiceSelect = service => {
    setService(service);
    inspectAll({
      userId: careUser.id,
      inspectionFor: [APPOINTMENT_INSPECTION.PROFILE],
    });
  };

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.servces" />
      <AppointmentHeader
        title="appointments.seeAProvider"
        subtitle={subtitle}
        handleBack={redirectToVisitType}
      />
      <div>
        {services.map(service => (
          <Shape
            onClick={() => handleServiceSelect(service)}
            renderPrimary={() => service.name}
            renderSecondary={() => service.description}
            key={service.id}
          />
        ))}
      </div>
    </Fragment>
  );
}

AppointmentServices.propTypes = {
  setService: PropTypes.func,
  inspectAll: PropTypes.func,
  careUser: PropTypes.object,
  services: PropTypes.array,
  subtitle: PropTypes.object,
};

export default enhance(AppointmentServices);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentServices/index.jsx